import { documentSampleTags } from '@theme/js/components/main/Jumio/components/DocumentSampleTags/DocumentTagsSample';
import { verifyNow } from './server';

export const handleRedirect = url => {
    const { handleJumioRedirect } = window.Playtech.API;

    if (typeof handleJumioRedirect === 'function') {
        handleJumioRedirect(url);

        return;
    }

    location.href = url;
};

export const getRedirectUrl = (type) => {
    const url = new window.URL(window.location.href);

    url.searchParams.set('jumioVerify', type);

    // restricted params
    [
        'transactionStatus',
        'customerInternalReference',
        'transactionReference',
        'errorCode'
    ].forEach(name => url.searchParams.delete(name));

    return url.toString();
};

export const handleBackClick = (setIsIframeLoaded, dynamicReducerDispatch, resetRedirectUrlAction) => {
    setIsIframeLoaded(false);
    dynamicReducerDispatch(resetRedirectUrlAction());
};

export const handleIframeLoaded = (setIsIframeLoaded) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    /* otherwise the button appears immediately while the iframe still loads for some time */
    setIsIframeLoaded(true);
};

const isTagAvailable = ({ playerTags }) => ({ name, values }) =>
    playerTags.some(tag => tag.name === name && values.includes(tag.value));

const getStatus = ({ playerTags }) => (tag) => {
    const statusTag = playerTags.find(({ name }) => name === tag.statusTag);
    tag.status = statusTag ? statusTag.value : 'empty';
    return Object.fromEntries(
        Object.entries(tag).filter(([key]) => !['name', 'values', 'statusTag'].includes(key))
    );
};

const translateDocs = ({ t }) => ({ documents, ...tag }) => ({
    ...tag,
    documents: documents.map(doc => ({
        ...doc,
        label: t(doc.label)
    }))
});

const processDocumentTags = (tagsDocument, options) =>
    tagsDocument.map(tag => ({
        ...tag,
        documents: tag.documents.map(doc => ({ ...doc }))
    }))
        .filter(isTagAvailable(options))
        .map(getStatus(options))
        .map(translateDocs(options));

export const processedTags = (options) => processDocumentTags(documentSampleTags, options);

export const handlePostMessage = (
    setIsIframeLoaded,
    dynamicReducerDispatch,
    resetRedirectUrlAction,
    log
) => ({ data }) => {
    try {
        if (typeof data === 'string') {
            const { eventType, payload: { value: status } = {} } = JSON.parse(data) || {};

            if (eventType === 510 && status !== 'loaded') {
                setTimeout(() => {
                    setIsIframeLoaded(false);
                    dynamicReducerDispatch(resetRedirectUrlAction());
                }, 1000);
            }
        }
    } catch (error) {
        log('error', error);
    }
};

export const handleVerifyNow = (documentType, dynamicReducerDispatch, setRedirectUrlAction) => {
    verifyNow({
        documentType,
        successUrl: getRedirectUrl('success'),
        errorUrl: getRedirectUrl('error')
    })
        .then(({ data: { redirectURL } }) => {
            dynamicReducerDispatch(setRedirectUrlAction(redirectURL));
        });
};
